import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import Input from '.';
import { InputIconsRenderer } from '../common';
const replaceCommas = (value) => value.replace(',', '.').replace(/,/g, '');
const createFloatRegExp = (decimalPlaces) => {
    const decimalPlacesCountPart = decimalPlaces === undefined ? '*' : `{0,${decimalPlaces}}`;
    return new RegExp(`^\\d*[.,]?\\d${decimalPlacesCountPart}$`);
};
const InputRenderer = forwardRef(function InputRenderer({ iconStart, iconEnd, intOnly, floatOnly, regexp, onChange, decimalPlaces, ...inputProps }, ref) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const isChangeAllowed = React.useCallback((e) => {
        if (intOnly && !/^\d*$/.test(e.target.value)) {
            return false;
        }
        if (floatOnly) {
            const floatOnlyRegExp = createFloatRegExp(decimalPlaces);
            return floatOnlyRegExp.test(e.target.value);
        }
        if (regexp && e.target.value.length !== 0) {
            return new RegExp(regexp).test(e.target.value);
        }
        return true;
    }, [decimalPlaces, floatOnly, intOnly, regexp]);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const handleChange = React.useCallback((event) => {
        if (isChangeAllowed(event)) {
            const { value } = event.target;
            event.target.value = floatOnly ? replaceCommas(value) : value;
            onChange?.(event);
        }
    }, [floatOnly, isChangeAllowed, onChange]);
    return (_jsx(InputIconsRenderer, { iconStart: iconStart, iconEnd: iconEnd, children: _jsx(Input, { ref: ref, ...inputProps, onChange: handleChange }) }));
});
export default React.memo(InputRenderer);
